import { createSlice } from '@reduxjs/toolkit';

export interface CurrencyTypes {
  id?: string | number;
  caption?: string;
  code?: string;
  currency_name?: string;
  currency_iso?: string;
  currency?: string;
}

export interface CurrencyState {
  currency: CurrencyTypes[];
  data: { currencyList: [] };
}

const initialState: CurrencyState = {
  currency: [],
  data: { currencyList: [] },
};

export const CurrencySlice = createSlice({
  name: 'currencyList',
  initialState,
  reducers: {
    setCurrencyState: (state, action) => {
      state.currency = [...action.payload];
    },
  },
});

export default CurrencySlice.reducer;

export const { setCurrencyState } = CurrencySlice.actions;
